import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/messageBar.css';
// constants
import {ASSETS_URL} from '../../../../constants/endpoints';
import {BASE_VALUE} from '../../../../constants/chips';
import {
    AMERICAN_FOOTBALL_MODULE,
    BASKETBALL_MODULE,
    FOOTBALL_MODULE,
    RACING_MODULE
} from '../../../../constants/identifiers';
import {FINISH_YOUR_BETS} from '../../constants/identifiers';
import {BET_TYPES as RACING_BET_TYPES} from '../../modules/racing/constants/identifiers';
import {BET_TYPES as FOOTBALL_BET_TYPES} from '../../modules/football/constants/identifiers';
// helpers
import {getText} from '../../../../helpers/localization';
import {getModuleFromEventType} from '../../../../helpers/moduleHelpers';
import {calculateTimeDifference} from '../../../../helpers/helperFunctions';
import {isEventInNoMoreBets} from '../../../../helpers/eventHelpers';
import {hasEventTypeRacerNumberUI} from '../../modules/racing/helpers/racersHelper';
// actions
import {addMessage} from '../../actions/messageBarActions';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        messageBar: state.vpp.messageBar,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        openBetsList: state.vpp.openBetsList
    };
};

class MessageBar extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            messageBar: storeData.vpp.messageBar,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            openBetsList: storeData.vpp.openBetsList
        };
    }

    _updateTimeLeft() {
        if (this.state.events.length > 0 && this.state.selectedEventIndex !== undefined && this.state.events[this.state.selectedEventIndex].eventTimeDate) {
            let eventTime = this.state.events[this.state.selectedEventIndex].eventTimeDate
            let timeLeft = Math.floor(calculateTimeDifference(new Date(), eventTime) / 1000);
            if (timeLeft === 30 || timeLeft === 15) {
                this.props.store.dispatch(addMessage(FINISH_YOUR_BETS));
            }
        }
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                messageBar: storeData.vpp.messageBar,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                openBetsList: storeData.vpp.openBetsList
            });
        }
    }

    _getMessage() {
        let messageBar = this.state.messageBar;
        if (messageBar.bet === undefined) {
            return this._getDefaultMessage();
        } else {
            switch (getModuleFromEventType(messageBar.bet.event.eventType)) {
                case RACING_MODULE:
                    return this._getRaceOpenBetMessage();
                case FOOTBALL_MODULE:
                case BASKETBALL_MODULE:
                case AMERICAN_FOOTBALL_MODULE:
                    return this._getFootballOpenBetMessage();
                default:

            }
            return this.state.messageBar.bet.stake;
        }

    }

    _getRaceOpenBetMessage() {
        let store = this.props.store;
        let storeData = store.getState();
        let amount = (this.state.messageBar.bet.stake / BASE_VALUE).toFixed(2);

        let racersUI = this.state.messageBar.bet.racers.map((racer, index) => {
            return (<div key={index} id={'slider_racer_silk_' + racer.num} className={style.racerIconContainer}>
                {
                    hasEventTypeRacerNumberUI(this.state.messageBar.bet.event.eventType)
                        ? (<div id={'slider_racer_number_' + racer.num} className={style.racerNumber}>{racer.num}</div>)
                        : ''
                }
                <img
                    src={`${ASSETS_URL}${storeData.vpp.games.filter((game) => game.channel === this.state.messageBar.bet.game.channel)[0].assetsPath}/silks/silk${Number(racer.silk) + 1}.png`}
                    className={style.racerIcon} alt={`icon${racer.silk}`}/>
            </div>);
        });

        let betType = RACING_BET_TYPES.find(betType => betType.code === this.state.messageBar.bet.market.code.toString());

        let payValue = (this.state.messageBar.bet.stake * this.state.messageBar.bet.market.odds / BASE_VALUE).toFixed(2);
        if (amount === '0.00') {
            return (<div className={style.mainContainer}>
                <div>{`${getText('MB_RACE_' + betType.name.toString(), this.props.store)} ${getText('BET', this.props.store)}  ${getText('ON', this.props.store)}`}</div>
                <div className={style.racers}>{racersUI}</div>
                <div>{`${getText('REMOVED', this.props.store)}`}</div>
            </div>);
        }

        return (<div className={style.mainContainer}>
            <div>{`$${amount} ${getText('MB_RACE_ON', this.props.store)}`}</div>
            <div className={style.racers}>{racersUI}</div>
            <div>{`${getText('MB_RACE_' + betType.name.toString(), this.props.store)} ${getText('PAYS', this.props.store)} $${payValue}`}</div>
        </div>);

    }

    _getFootballOpenBetMessage() {
        let amount = (this.state.messageBar.bet.stake / BASE_VALUE).toFixed(2);

        let betType = FOOTBALL_BET_TYPES.find(betType => betType.code === this.state.messageBar.bet.market.code.toString());
        let payValue = (this.state.messageBar.bet.stake * this.state.messageBar.bet.market.odds / BASE_VALUE).toFixed(2);

        return (<div className={style.mainContainer}>
            <div>{`$${amount} ${getText('MB_FOOTBALL_ON', this.props.store)}`}</div>
            <div className={style.racers}>{getText(betType.name.toString(), this.props.store)}</div>
            <div>{`${getText('PAYS', this.props.store)} $${payValue}`}</div>
        </div>);

    }

    _getDefaultMessage() {
        if (this.state.events.length > 0 && this.state.selectedEventIndex !== undefined && this.state.events[this.state.selectedEventIndex].eventTimeDate) {
            let selectedEvent = this.state.events[this.state.selectedEventIndex];
            let eventTime = selectedEvent.eventTimeDate;
            // let eventId = selectedEvent.eventId;
            let timeLeft = Math.floor(calculateTimeDifference(new Date(), eventTime) / 1000);

            if (isEventInNoMoreBets(selectedEvent, this.state.noMoreBetsEventList)) {
                return (<div className={style.orange}>{getText('NO_MORE_BETS', this.props.store)}</div>);
            } else if (timeLeft >= 16 && timeLeft <= 30) {
                return (<div className={style.orange}>{getText('FINISH_YOUR_BETS', this.props.store)}</div>);
            } else if (timeLeft >= 0 && timeLeft <= 15) {
                return (<div className={style.red}>{getText('FINISH_YOUR_BETS', this.props.store)}</div>);
            }
        }
        return getText('PLACE_YOUR_BETS', this.props.store);
    }

    render() {
        return (<div id={'messageBar'} className={style.wrapperContainer}>{this._getMessage(this.props.store)}</div>);
    }

    _isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
}

export default connect(mapStateToProps)(MessageBar);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/components/messageBar.js